import { useQuery } from "@tanstack/react-query";
import { from, unwrap } from "@vixio/data";
import type { KpiView } from "./api";

/** Dados dos painéis do Início: ficam fora das telas para que elas carreguem sob demanda. */
export function useKpis(orgId: string) {
  return useQuery({ queryKey: ["analytics", "kpis", orgId], queryFn: () => unwrap<KpiView[]>(from("analytics", "v_kpis").select("*").eq("org_id", orgId).order("position")) });
}
